import { Outlet, useOutletContext, useParams } from "react-router-dom";
import { Box, Button, CircularProgress, Grid } from "@mui/material";
import { useLiveResolver } from "../../hooks/useLiveResolver.js";
import { useMatchIdMapping } from "../../hooks/useMatchIdMapping.js";
import LiveExport from "../../../components/Live/LiveExport.js";
import DsasButton from "../../components/DsasButton/DsasButton.js";
import { faMicrophoneLines } from "@fortawesome/free-solid-svg-icons";

const DirectDetailResolver = () => {

    const { id, mode, date } = useParams();
    const queryParameters = new URLSearchParams(window.location.search)
    const competition = queryParameters.get("competition")

    const {liveDates, liveCompetitionsDays} = useOutletContext();

    const [live] = useLiveResolver(id, mode, date, competition)

    const [matchIdMapping, getIdMatchFromMatchName] = useMatchIdMapping(live)

    const handleOpenLive = () => {
        let urlLocation = undefined
        //On récupère l'url de live
        if(process.env.NODE_ENV === 'development'){
          urlLocation = 'http://localhost:3006';
        }else{
          urlLocation = process.env.REACT_APP_LIVE_CLIENT_URL;
        }
  
        const url = urlLocation + "/"+id 
  
        window.open(url, '_blank', 'toolbar=0,location=0,menubar=0');
      }
  
    if(!live || !Object.keys(live).length)
        return <CircularProgress />

    return <>
                <Box className='centered-medium-wrapper'>
                    <h1 className='page-title'>Direct Sport</h1>
                </Box>
                <Box className='large-separator'></Box>
                <Box className='padding-wrapper'>
                  <Grid container>
                      <Grid item alignSelf={"flex-start"} xs={6} sm={3} md={2}>
                        {/*Bouton Ouvrir le direct*/}
                        <DsasButton icon={faMicrophoneLines} label="Ouvrir le direct" variant = 'secondary' onClick={handleOpenLive} />
                      </Grid>
                      <Grid item xs={1} sm={6} md={8}>
                      </Grid>
                      <Grid item alignSelf={"flex-end"} xs={5} sm={3} md={2}>
                        {/*Bouton Export*/}
                        <Box sx={{display:"grid"}}>
                          <Box sx={{justifySelf:"right"}}><LiveExport idLive={id} isActu={false} live={live}/></Box>
                        </Box>
                      </Grid>
                  </Grid>

                  <Box className="small-padding"></Box>
                   
                  <Outlet context={{live, liveDates, liveCompetitionsDays, matchIdMapping, getIdMatchFromMatchName}}/>

                </Box>
    </>;
};

export default DirectDetailResolver